import React, { useState } from "react";
import { DarkGrey } from "../../styles/colors";

interface CopyLinkProps {
  link: string;
  displayText?: string;
}

const CopyLinkButton: React.FC<CopyLinkProps> = ({ link, displayText }) => {
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy: ", err);
      // Fallback for older browsers
      const textArea = document.createElement("textarea");
      textArea.value = link;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    }
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <input
        type="text"
        value={displayText || link}
        readOnly
        style={{
          padding: "8px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          flexGrow: 1,
          color: DarkGrey,
        }}
      />
      <button
        onClick={copyToClipboard}
        style={{
          padding: "8px 16px",
          backgroundColor: isCopied ? "#1e2e5580" : "#1e2e55",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
          minWidth: "100px",
        }}
      >
        {isCopied ? "Copied!" : "Copy"}
      </button>
    </div>
  );
};

export default CopyLinkButton;
